import { useTheme } from '@mui/material';
import { linearGradientDef } from '@nivo/core';
import { ResponsiveLine } from '@nivo/line';
import { BasicTooltip } from '@nivo/tooltip';
import GraphDataProps from 'common/types/GraphDataProps';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomPoint = (props:any) => {
  const { currentPoint } = props;
  // it will show the current point
  if (currentPoint) {
    return (
          <g>
            <circle
              r={3}
              strokeWidth={'1'}
              stroke={'#f98c0b'}
              fill={'#f98c0b'}
              fillOpacity={0.85}
              cx={currentPoint.x}
              cy={currentPoint.y}
            />
          </g>
    );
  }
  return <></>;
};

type FinancesGraphProps = {
  data: GraphDataProps[];
};


export default function FinancesGraph({ data }:FinancesGraphProps) {
  const theme = useTheme();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const NonOverflowTooltipWrapper = (props: any) => {
    const [tooltipSize, setTooltipSize] = React.useState<{
      width: number;
      height: number;
    }>({ width: 0, height: 0 });
      
    // dynamically get the size of the tooltip
    React.useEffect(() => {
      const tooltip = document.querySelector('.nivo_tooltip');
      if (tooltip) {
        const { width, height } = tooltip.getBoundingClientRect();
        setTooltipSize({ width, height });
      }
    }, [setTooltipSize]);
      
    // only show it to the right of the pointer when we are close to the left edge
    const translateX = React.useMemo(
      () =>
        props.point.x < (tooltipSize.width * 1.3) / 2 ? 0 : -tooltipSize.width,
      [tooltipSize, props.point.x],
    );
      
    // only show it below the pointer when we are close to the top edge
    const translateY = React.useMemo(
      () =>
        props.point.y < (tooltipSize.height * 1.3) / 2 ? 0 : -tooltipSize.height,
      [tooltipSize, props.point.y],
    );
      
    return (
          <div
            className={'nivo_tooltip'}
            style={{
              position: 'absolute',
              transform: `translate(${translateX}px, ${translateY}px)`,
              width: 'fit-content',
            }}
          >
            <div style={{ position: 'relative' }}><BasicTooltip
                id={props.point.data.xFormatted}
                
                value={props.point.data.yFormatted + ' грн.'}
            /></div>
          </div>
    );
  };

  return (
        <ResponsiveLine
            data={data}
            curve='monotoneX'
            margin={{ top: 50, right: 24, bottom: 50, left: 48 }}
            enableArea={true}
            layers={[CustomPoint, 'grid', 'axes', 'areas', 'crosshair', 'lines', 'slices', 'mesh', 'legends']}
            theme={{
              fontFamily: 'Mulish',
              fontSize: 16,
              textColor: theme.colors.primaryTextColor,
              axis: {
                domain: {
                  line: {
                    stroke: theme.colors.gray,
                    strokeWidth: 0,
                  },
                },
                ticks: {
                  line: {
                    stroke: theme.colors.gray,
                    strokeWidth: 0,
                  },
                },
              },
              grid: {
                line: {
                  stroke: theme.colors.gray,
                  strokeWidth: .2,
                },
              },
            }}
            isInteractive={true}
            areaOpacity={1}
            useMesh={true}
            colors={['#f98c0b']}
            tooltip={NonOverflowTooltipWrapper}
            enableGridX={false}
            enablePoints={true}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any

            defs={[
              // using helpers
              // will inherit colors from current element
              linearGradientDef('gradient', [
                { offset: 0, color: 'inherit', opacity: .1 },
                { offset: 200, color: 'inherit', opacity: 1 },
              ]),
            ]}
            fill={[
              { match: '*', id: 'gradient' },
            ]}
        />
  );
}